import {ADD_NEW_TICKET, FETCH_NEW_TICKETS, LIST_NEW_TICKETS, SET_MARK, UPDATE_TICKET} from "./types";

const init = {
    isLoading: false,
    lanes: [],
    isMark: false,
    filter: {},
    page: 1,
    totals: 0,
    size: 10
};

export default (state = init, {type, payload, paging}) => {
    switch (type) {
        case FETCH_NEW_TICKETS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_NEW_TICKETS:
            return {
                ...state,
                isLoading: false,
                lanes: payload,
                ...paging
            };

        case UPDATE_TICKET:
            return {
                ...state,
                isLoading: true,
            };

        case ADD_NEW_TICKET:

            const ticket = payload.cards[0];
            const isExist = state.lanes.filter(e => e.cards[0].ticketNumber === ticket.ticketNumber).length > 0;
            if (state.isMark || ticket.drawCode !== state.filter.drawCode || isExist) {
                return state;
            }
            let lanes;
            let {totals, page, size} = state;
            if (state.lanes.length >= state.filter.size) {
                if ((totals / size) > page + 1) {
                    lanes = state.lanes;
                    totals++;
                } else {
                    page++;
                    lanes = [payload];
                    totals++;
                }
            } else {
                lanes = [...state.lanes, payload];
                totals++;
            }
            return {
                ...state,
                lanes: lanes,
                totals: totals,
                page: page
            };
        case SET_MARK:
            return {
                ...state,
                isMark: !state.isMark,
            };
        default:
            return state;
    }
}
